module.exports = __webpack_public_path__ + "static/media/ArrowRightGrey.16c8a9df.svg";